export default {"src":"/_next/static/media/enhance.de254f4c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};